import { useQuery } from '@tanstack/react-query';
import { searchService } from 'shared/src/api';
import { queryKey } from '../../../constants/queryKey';

export const useAssistantInfo = (query: string) => {
  return useQuery({
    queryKey: queryKey.assistantInfo(query),
    queryFn: () => searchService.getAssistantInfo({ query }),
    enabled: query.length > 0,
    staleTime: 1000 * 60 * 5, // 5분
  });
};